import React, { Component /* , createRef */ } from 'react'
import { connect } from 'react-redux'
import blank from './blank'
import contactfield from './contactfield'
import field from './field'
import htmlcontent from './htmlcontent'
import image from './image'
import separator from './separator'
import title from './title'
import pagebreak from './pagebreak'
import {
  selectSection,
  editSection,
  deleteSection,
  changeSection,
  cancelEdit,
} from 'actions/customForm/addOrEdit'
import { bindActionCreators } from 'redux'
import {
  IconButton,
  withStyles,
  Menu,
  MenuItem,
  ListItemIcon,
  Tooltip,
} from '@material-ui/core'
import {
  MoreVert,
  Done,
  Edit,
  Delete,
  Cancel,
  VisibilityOff,
} from '@material-ui/icons'
import { PageNext, PencilOff } from 'mdi-material-ui'
import MoveToPageMenuOptions from '../MoveToPageMenuOptions'
import { pagebreaksBool } from 'selectors/customform'

const sectionTypes = {
  blank,
  contactfield,
  field,
  htmlcontent,
  image,
  separator,
  title,
  pagebreak,
}

const styles = theme => ({
  iconButtonRoot: {
    padding: 3,
  },
  green: {
    color: theme.palette.green,
  },
  paper: {
    maxHeight: 250,
  },
  dimmed: {
    position: 'relative',
    // '&:after': {
    // 	content: '" "',
    // 	zIndex: 10,
    // 	display: 'block',
    // 	position: 'absolute',
    // 	height: '100%',
    // 	top: 0,
    // 	left: 0,
    // 	right: 0,
    // 	background: 'rgb(0 0 0 / 23%)',
    // },
  },
  item: {
    position: 'relative',
  },
})

class ItemUI extends Component {
  constructor(props) {
    super(props)

    this.state = {
      anchorEl: null,
      menuSelected: 'default',
    }

    // this.itemRef = createRef()
  }

  // componentDidMount() {
  // 	setTimeout(() => {
  // 		this.setState({ height: this.itemRef?.current?.clientHeight })
  // 	}, 1)
  // }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  selectMenu = menuSelected => {
    this.setState({ menuSelected })
  }

  render() {
    const { menuSelected, anchorEl } = this.state

    const Component = sectionTypes[this.props.item.type] || blank

    const moreButton = (
      <div
        style={{
          position: 'absolute',
          right: 3,
          top: '50%',
          transform: 'translate(0, -50%)',
          zIndex: 11,
        }}
      >
        <IconButton
          onClick={e => this.setState({ anchorEl: e.currentTarget })}
          aria-haspopup="true"
          aria-owns={anchorEl ? 'customFormSectionMoreMenu' : undefined}
          classes={{
            root: this.props.classes.iconButtonRoot,
          }}
        >
          <MoreVert />
        </IconButton>
      </div>
    )

    const defaultMenuOptionsWithoutMoveToPage = [
      <MenuItem
        key="defaultMenuItemEdit"
        disabled={
          this.props.isEditing ||
          this.props.item.type === 'separator' ||
          this.props.item?.contactfield?.field_name === 'phone_opt' ||
          this.props.item?.contactfield?.field_name === 'email_opt'
        }
        onClick={() => {
          this.handleClose()
          this.props.editSection({
            index: this.props.index,
            item: this.props.item,
          })
        }}
      >
        <ListItemIcon>
          <Edit />
        </ListItemIcon>
        Edit
      </MenuItem>,
      <MenuItem
        key="defaultMenuItemDelete"
        disabled={
          this.props.item?.contactfield?.field_name === 'phone_opt' ||
          this.props.item?.contactfield?.field_name === 'email_opt'
        }
        onClick={() => {
          this.handleClose()
          this.props.deleteSection(this.props.index)
        }}
      >
        <ListItemIcon>
          {this.props.item.type === 'blank' ? <Cancel /> : <Delete />}
        </ListItemIcon>
        {this.props.item.type === 'blank' ? 'Cancel' : 'Delete'}
      </MenuItem>,
    ]

    const defaultMenuOptions = this.props.pagebreaksBool
      ? [
          <MenuItem
            key="defaultMenuItemMoveToPage"
            onClick={() => {
              this.selectMenu('moveToPage')
            }}
          >
            <ListItemIcon>
              <PageNext />
            </ListItemIcon>
            Move to page
          </MenuItem>,
          ...defaultMenuOptionsWithoutMoveToPage,
        ]
      : defaultMenuOptionsWithoutMoveToPage

    return this.props.item.type === 'pagebreak' ? null : (
      <div
        onMouseDown={() =>
          this.props.selectSection(this.props.index, this.props.item)
        }
        onTouchStart={() =>
          this.props.selectSection(this.props.index, this.props.item)
        }
      >
        <div
          // ref={this.itemRef}
          className={
            this.props.item?.field?.hidden && !this.props.isEditing
              ? this.props.classes.dimmed
              : this.props.classes.item
          }
          style={
            this.props.isDragging ||
            this.props.isSelected ||
            this.props.isEditing
              ? this.props.isDragging
                ? {
                    visibility: 'hidden',
                  }
                : {
                    // position: 'relative',
                    paddingTop: 10,
                    paddingBottom: 10,
                    backgroundColor: '#fff',
                    color: '#000',
                    marginRight: -20,
                    marginLeft: -20,
                    paddingLeft: 20,
                    paddingRight: 20,
                    boxShadow: '0px 5px 5px #00000040, 0px -5px 5px #00000040',
                  }
              : {
                  // position: 'relative',
                }
          }
        >
          {(this.props.item?.field?.hidden ||
            this.props.item?.field?.readonly) &&
            !this.props.isEditing && (
              <>
                <div
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 11,
                  }}
                >
                  {this.props.item?.field?.hidden && (
                    <Tooltip title="This field is hidden">
                      <VisibilityOff style={{ color: '#fff', fontSize: 36 }} />
                    </Tooltip>
                  )}
                  {this.props.item?.field?.readonly && (
                    <Tooltip title="This field is read only">
                      <PencilOff style={{ color: '#fff', fontSize: 36 }} />
                    </Tooltip>
                  )}
                </div>
                <div
                  style={{
                    zIndex: 10,
                    display: 'block',
                    position: 'absolute',
                    height: '100%',
                    top: 0,
                    left: 0,
                    right: 0,
                    background: 'rgb(0 0 0 / 15%)',
                  }}
                />
              </>
            )}
          <div
            style={{
              padding: '0 20px',
            }}
          >
            <Component
              isOver={this.props.isOver}
              item={this.props.item}
              isDragging={this.props.isDragging}
              isEditing={this.props.isEditing}
              index={this.props.index}
            />
          </div>
          {/* {this.props.isDragging || this.props.isSelected ? (
					<>
						<div
							style={{
								position: 'absolute',
								height: 3,
								backgroundColor: '#66a8e8',
								top: 0,
								width: 'calc(100% + 40px)',
								left: -20,
							}}
						/>
						<div
							style={{
								position: 'absolute',
								height: 3,
								backgroundColor: '#66a8e8',
								bottom: 0,
								width: 'calc(100% + 40px)',
								left: -20,
							}}
						/>
					</>
				) : null} */}
          {(this.props.isSelected || this.props.isEditing) && moreButton}
          {this.props.isEditing && this.props.item.type !== 'blank' && (
            <>
              <div
                style={{
                  position: 'absolute',
                  top: 6,
                  right: 3,
                }}
              >
                <Tooltip title="Cancel">
                  <IconButton
                    onClick={() => {
                      this.props.cancelEdit()
                    }}
                    style={{
                      backgroundColor: 'red',
                      color: '#fff',
                    }}
                    classes={{
                      root: this.props.classes.iconButtonRoot,
                    }}
                  >
                    <Cancel />
                  </IconButton>
                </Tooltip>
              </div>
              <div
                style={{
                  position: 'absolute',
                  bottom: 6,
                  right: 3,
                }}
              >
                <Tooltip title="Confirm changes">
                  <IconButton
                    onClick={() => {
                      this.props.editSection(undefined)
                    }}
                    style={{
                      backgroundColor: '#15b940',
                      color: '#fff',
                    }}
                    classes={{
                      root: this.props.classes.iconButtonRoot,
                    }}
                  >
                    <Done />
                  </IconButton>
                </Tooltip>
              </div>
            </>
          )}
          <Menu
            id="customFormSectionMoreMenu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
            classes={{
              paper: this.props.classes.paper,
            }}
          >
            {menuSelected === 'default' ? (
              defaultMenuOptions
            ) : (
              <MoveToPageMenuOptions
                index={this.props.index}
                selectMenu={this.selectMenu}
                handleClose={this.handleClose}
              />
            )}
          </Menu>
        </div>
        {this.props.isDragging && (
          <>
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                color: '#66a8e8',
                fontSize: 16,
                fontWeight: 'bold',
                backgroundColor: '#fff',
                zIndex: 1,
                padding: 10,
              }}
            >
              Drop Here
            </div>
            <div
              style={{
                height: 3,
                backgroundColor: '#66a8e8',
                position: 'absolute',
                width: '100%',
                top: '50%',
                transform: 'translate(0, -50%)',
              }}
            />
          </>
        )}
      </div>
    )
  }
}

export default connect(
  (state, { index, item }) => ({
    isEditing: state.customForm.addOrEdit.sectionBeingEditedID === item.id,
    isSelected: state.customForm.addOrEdit.sectionSelected === index,
    // pagebreaksBool: Boolean(
    // 	state.customForm.addOrEdit.form.sections
    // 		.map((id, idx) => ({
    // 			...state.customForm.addOrEdit.sectionsByID[id],
    // 			idx,
    // 		}))
    // 		.filter((el) => el?.type === 'pagebreak').length,
    // ),
    pagebreaksBool: pagebreaksBool(state),
  }),
  dispatch =>
    bindActionCreators(
      { selectSection, editSection, deleteSection, changeSection, cancelEdit },
      dispatch,
    ),
)(withStyles(styles)(ItemUI))
